import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Navbar, Nav } from 'react-bootstrap';
import { List, X } from 'react-bootstrap-icons';

export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <Navbar
      expand="lg"
      fixed="top"
      className={`qmi-navbar ${isScrolled ? 'qmi-navbar-scrolled' : 'qmi-navbar-transparent'}`}
      expanded={isMenuOpen}
    >
      <Container fluid={!isHomePage}>
        <Navbar.Brand href="/" className="qmi-navbar-brand">
          <img
            src="./qmi.png"
            alt="Quote My Injury"
            className="qmi-navbar-logo"
          />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="main-navbar"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="qmi-navbar-toggle"
        >
          {isMenuOpen ? <X size={24} /> : <List size={24} />}
        </Navbar.Toggle>

        <Navbar.Collapse id="main-navbar">
          <Nav className="ms-auto align-items-lg-center">
            <Nav.Link
              onClick={() => scrollToSection('how-it-works')}
              className="qmi-nav-link"
            >
              How It Works
            </Nav.Link>
            <Nav.Link
              onClick={() => scrollToSection('earn')}
              className="qmi-nav-link"
            >
              Earn
            </Nav.Link>
            {/* Marketplace moved to admin area - now requires login */}
            <Nav.Link
              href="/dashboard"
              className="qmi-nav-link"
            >
              Sign In
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
